import { createTheme } from '@mui/material';
import { baseTheme } from './baseTheme';

export default createTheme({
  ...baseTheme,
  palette: {
    mode: 'light',
    primary: {
      main: '#A3CD32',
      light: '#D9FF75',
      dark: '#647F1B',
      contrastText: '#3A3E46',
    },
    secondary: {
      main: '#0F53B7',
      light: '#408DFF',
      dark: '#002965',
      contrastText: '#FFFFFF',
    },
    error: {
      main: '#D32F2F',
      light: '#FFEBEE',
      dark: '#B71C1C',
      contrastText: '#FFFFFF',
    },
    neutral: {
      main: '#E0E0E0',
      contrastText: '#666666',
    },
    background: {
      default: '#FAF7F2',
      paper: '#FFFFFF',
    },
    text: {
      primary: '#333333',
      secondary: '#666666',
    },
  },
  typography: {
    fontFamily: [
      '-apple-system',
      'BlinkMacSystemFont',
      'San Francisco',
      'Helvetica Neue',
      'Helvetica',
      'Arial',
      'sans-serif',
    ].join(','),
    h1: {
      fontWeight: 600,
      letterSpacing: '-0.015em',
      lineHeight: 1.2,
    },
    h2: {
      fontWeight: 600,
      letterSpacing: '-0.01em',
      lineHeight: 1.3,
    },
    h3: {
      fontWeight: 500,
      letterSpacing: '-0.01em',
      lineHeight: 1.3,
    },
    h4: {
      fontWeight: 500,
      letterSpacing: '-0.008em',
      lineHeight: 1.4,
    },
    h5: {
      fontWeight: 500,
      letterSpacing: '-0.005em',
      lineHeight: 1.4,
    },
    h6: {
      fontWeight: 500,
      letterSpacing: '-0.003em',
      lineHeight: 1.5,
    },
    body1: {
      lineHeight: 1.5,
      letterSpacing: '-0.003em',
    },
    body2: {
      lineHeight: 1.5,
      letterSpacing: '-0.002em',
    },
    button: {
      textTransform: 'none',
      fontWeight: 500,
      letterSpacing: '-0.003em',
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          borderRadius: 2,
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          borderRadius: 6,
          boxShadow: '0 4px 12px rgba(0,0,0,0.05)',
        },
      },
    },
    MuiAppBar: {
      styleOverrides: {
        root: {
          boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
        },
      },
    },
  },
  shape: {
    borderRadius: 2,
  },
  custom: {
    titleSpacing: {
      marginBottom: 1, // 16px (2 * 8px)
    }
  }
}); 